import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import moment from "moment";
import SelectSearch from "react-select-search";

import appointmentService from "../../services/appointmentService";
import questionnaireService from "../../services/questionnaireService";
import QuestionnaireModal from "./QuestionnaireModal";

const RequestAppointmentModal = (props) => {
  const { buttonLabel, id, clearNotification, target } = props;
  const [modal, setModal] = useState(false);
  const [user, setUser] = useState({});
  const [questionnaire, setQuestionnaire] = useState({});
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState("0");
  const [attorney, setAttorney] = useState({});

  useEffect(() => {
    if (id !== "") {
      //console.log(id);
      appointmentService.getLitigantByEmail({ id: id }).then((payload) => {
        setUser(payload);
        //console.log(payload);
      });
    }
  }, [id]);

  useEffect(() => {
    if (Object.keys(user).length !== 0) {
      //console.log(user.token);
      questionnaireService
        .getCurrentUserQuestionnaireStaff(user.token)
        .then((payload) => setQuestionnaire(payload));
    }
  }, [user]);

  useEffect(() => {
    appointmentService.getAppointmentsForRequest().then((payload) => {
      let renamedArray = payload.map((a) => {
        return {
          name:
            moment(a.timeSlotStart).format("ddd MMM-DD-YYYY hh:mm A") +
            " - " +
            moment(a.timeSlotEnd).format("hh:mm A"),
          value: a.appointmentId,
          lit: { ...a },
        };
      });
      console.log(renamedArray);
      setDates(renamedArray);
    });
  }, []);

  const onSelect = (id) => {
    setSelectedDate(id);
    const date = dates.find((val) => val.value === id);
    const att = { ...date.lit };
    //console.log(att);
    appointmentService.getAttorney({ id: att.attorneyId }).then((payload) => {
      setAttorney(payload);
    });
  };

  const toggle = () => setModal(!modal);

  const confirmAppt = () => {
    const apptId = { userId: user.token, appointmentId: selectedDate };
    appointmentService.setAppointmentLitigant(apptId).then(() => {
      clearNotification(target.toString());
      toggle();
    });
  };
  return (
    <div>
      <Button
        color="link"
        onClick={toggle}
        style={{ padding: 0, margin: 0, textAlign: "left" }}
      >
        {buttonLabel}
      </Button>
      <Modal size={"xl"} isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{buttonLabel}</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Row>
                <Col>
                  <h5>Litigant info</h5>
                  <p>
                    {user.firstName} {user.lastName}
                    <br />
                    {moment(user.dob).format("MM/DD/YYYY")}
                    <br />
                    {user.userName}
                    <br />
                    {user.phoneNumber}
                    <br />
                    <QuestionnaireModal
                      buttonLabel="View Questionnaire"
                      color="primary"
                      userId={user.token}
                      qId={questionnaire.userQuestionnaireId}
                      hasCurrentQuestionnaire={true}
                      modalTitle="View Questionnaire"
                      readOnly={true}
                    />
                    {user.userId}
                  </p>
                </Col>
              </Row>
            </Col>
            <Col>
              <h5>Available appointments</h5>
              <br /> 
              <FormGroup>
                <Label for="exampleSelectMulti">The appointments below have an attorney assinged and are available.</Label>
                <SelectSearch
                options={dates}
                search
                placeholder="Available dates"
                onChange={(id) => onSelect(id)}
                />
                {/* <Input
                  type="select"
                  name="selectMulti"
                  id="exampleSelectMulti"
                  onClick={(e) => onSelect(e.target.value)}
                  multiple
                >
                  {dates.map((m) => (
                    <option key={m.value} value={m.value}>{m.name}</option>
                  ))}
                </Input> */}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}></Col>
            <Col>
              {Object.keys(attorney).length !== 0 && (
                <div>
                  <h5>Attorney info</h5>
                  <p>
                    {attorney.firstName} {attorney.lastName}
                    <br />
                    {attorney.token}
                    <br />
                    {attorney.userName}
                    <br />
                    {attorney.phoneNumber}
                    <br />
                  </p>
                </div>
              )}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <span style={{ fontStyle: "italic" }}>
            Clicking submit will assign the appointment and clear the
            notification.
          </span>
          <Button
            color="primary"
            disabled={selectedDate > 0 ? false : true}
            onClick={confirmAppt}
          >
            Submit
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default RequestAppointmentModal;
